import { useSelector } from 'react-redux';
import { useQuery } from '@apollo/client';
import { GET_TOTAL_CART_PRODUCTS } from '@/common/SharedQueries';

export default function useCartCount() {
  const isAuthenticated = useSelector(state => state.Auth.isAuthenticated);
  const total = useSelector(state => state.LocalCart.total);

  const { loading, data, error } = useQuery(GET_TOTAL_CART_PRODUCTS, {
    skip: !isAuthenticated,
    fetchPolicy: 'network-only'
  });

  if (error) {
    console.error('Error loading cart count', error);
    return { cartCount: 0 };
  }

  if (loading) return { cartCount: 0 };

  if (isAuthenticated && data.getTotalCartProducts.total) {
    return { cartCount: data.getTotalCartProducts.total };
  }

  if (!isAuthenticated && total) {
    return { cartCount: total }
  } 

  return { cartCount: 0 };
}